import { render } from "./uploadDocument.vue?vue&type=template&id=66a08cc9&scoped=true"
import script from "./uploadDocument.vue?vue&type=script&lang=js"
export * from "./uploadDocument.vue?vue&type=script&lang=js"

import "./uploadDocument.vue?vue&type=style&index=0&id=66a08cc9&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a08cc9"]])

export default __exports__